import React from "react";

const CustomCheckbox = ({ error, number, label, inline, ...rest }) => (
  <div
    className={inline !== undefined ? "checkbox checkbox-inline" : "checkbox"}
  >
    <input id={number} type="checkbox" {...rest} />
    <label htmlFor={number}><b>{label}</b></label>
    {error && <p className="text-danger">{error}</p>}
  </div>
);

export default CustomCheckbox;
